import { render, staticRenderFns } from "./UserAgreementDemo.vue?vue&type=template&id=3950c7fc&scoped=true"
import script from "./UserAgreementDemo.vue?vue&type=script&lang=js"
export * from "./UserAgreementDemo.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementDemo.vue?vue&type=style&index=0&id=3950c7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950c7fc",
  null
  
)

export default component.exports